import { lazy } from 'react'

const AddPoint = lazy(() => import('../../views/pages/character/add-point'))
const ChangeClass = lazy(() => import('../../views/pages/character/change-class'))
const ChangeName = lazy(() => import('../../views/pages/character/change-name'))
const ClearPK = lazy(() => import('../../views/pages/character/clear-pk'))
const JewelToBank = lazy(() => import('../../views/pages/character/jewel-to-bank'))
const Reset = lazy(() => import('../../views/pages/character/reset'))
const ResetPoint = lazy(() => import('../../views/pages/character/reset-point'))
const Title = lazy(() => import('../../views/pages/character/title'))
const QuestDaily = lazy(() => import('../../views/pages/character/questdaily'))

const routes = [
	{
		path: '/character/add-point',
		element: <AddPoint />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/character/change-class',
		element: <ChangeClass />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/character/change-name',
		element: <ChangeName />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/character/clear-pk',
		element: <ClearPK />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/character/jewel-to-bank',
		element: <JewelToBank />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/character/reset',
		element: <Reset />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/character/reset-point',
		element: <ResetPoint />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/character/title',
		element: <Title />,
		meta: {
			publicRoute: false
		}
	},
	{
		path: '/character/questdaily',
		element: <QuestDaily />,
		meta: {
			publicRoute: false
		}
	}
]

export default routes
